import { render } from "./DrugstoresList.vue?vue&type=template&id=1209ef3d&scoped=true"
import script from "./DrugstoresList.vue?vue&type=script&lang=js"
export * from "./DrugstoresList.vue?vue&type=script&lang=js"

import "./DrugstoresList.vue?vue&type=style&index=0&id=1209ef3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1209ef3d"]])

export default __exports__